export default function Button({ children, bg="accent", onClick=() => {} }) {
    return (
      <div onClick={onClick} className={"cursor-pointer bg-" + bg + " border-white borde px-8 py-4 rounded-lg text-white font-bold"}>
        {children}
      </div>
    );
  } 